import _ from 'lodash';
import IndustryInfo from '@/business-components/sale/IndustryInfo';
import AreaInfo from '@/business-components/sale/AreaInfo';
import OriginalSourceTypeTag from '@/business-components/sale/OriginalSourceTypeTag';
import UserInfo from '@/business-components/sale/UserInfo';
import PromotedObjectInfo from '@/business-components/sale/PromotedObjectInfo';
import RegistrationAdPlatformTypeInfo from '@/pages/agency/register/components/RegistrationAdPlatformTypeInfo';
import { LEAD_LAYER_TYPE, ADVERTISE_EXPERIENCE, BUSINESS_BASE, DELIVERY_AREA } from '@/constants/Constants';
import React from 'react';

// 需要单独处理的 key 的白名单；
const whiteList = [
  'intention',
  'advertise_experience',
  'business_base',
  'delivery_area',
  'isFinancing',
];

/**
 * @description: 处理变更日志
 * @param {*} data
 * @param {*} mapping
 * @return {*}
 */
export const handleChangePart = (data, mapping) => {
  const handleLabel = (key) => {
    return mapping[key] && <strong>{mapping[key]}: </strong>;
  };

  const handle = (_data, className) => {
    const key = _.keys(_data);

    return key.map((v, i) => {
      let item = _data[v];
      // 推广目标intention，不需要展开
      if (_.isObject(item) && !whiteList.includes(v)) {
        const length = _.values(item).length;
        if (v === 'mobile' || v === 'telephone') {
          const comma = length > 1 ? (i < length - 1 ? ', ' : '') : '';
          let str = '';
          str += item.map((d) => {
            return `${d}${comma}`;
          });
          return (
            <span className="pave" key={v}>
              {handleLabel(v)}
              {str}
            </span>
          );
        }
        return (
          <div className={v === 'contact_info_vos' ? 'modify-log-item' : ''} key={i}>
            {handleLabel(v)}
            {length > 0 && handle(item, 'pave')}
          </div>
        );
      }
      if (item || v === 'is_financing') {
        switch (v) {
          case 'industry_id':
            item = <IndustryInfo industryId={item} />;
            break;
          case 'area_id':
            item = <AreaInfo areaCode={item} />;
            break;
          case 'source_type_tag':
            item = <OriginalSourceTypeTag sourceTypeTag={item} />;
            break;
          case 'owner_id':
            item = <UserInfo key={item} userId={item} />;
            break;
          case 'ad_platform_type':
            item = <RegistrationAdPlatformTypeInfo value={item} />;
            break;
          case 'intention':
            const promotedObject = {
              ...item,
              adPlatformType: item?.ad_platform_type,
              adPlatformTypes: item?.ad_platform_types || item?.ad_platform_type,
              promotedObject: item?.promoted_object,
            };
            item = <PromotedObjectInfo promotedObject={promotedObject} />;
            break;
          case 'lead_layer_type':
            item = LEAD_LAYER_TYPE[item];
            break;
          case 'advertise_experience':
            item = item?.map(item => ADVERTISE_EXPERIENCE[item]).join(',');
            break;
          case 'business_base':
            item = item?.map(item => BUSINESS_BASE[item]).join(',');
            break;
          case 'delivery_area':
            item = item?.map(item => DELIVERY_AREA[item]).join(',');
            break;
          case 'is_financing':
            item = item ? '是' : '否';
            break;
          case 'max_advertise_budget':
            item = item / 100;
            break;
          case 'max_customer_price':
            item = item / 100;
            break;
          case 'max_daily_consume':
            item = item / 100;
            break;
          case 'max_month_total_sales':
            item = item / 100;
            break;
          case 'min_advertise_budget':
            item = item / 100;
            break;
          case 'min_customer_price':
            item = item / 100;
            break;
          case 'min_daily_consume':
            item = item / 100;
            break;
          case 'min_month_total_sales':
            item = item / 100;
            break;
          default:
            item = item;
            break;
        }
        return (
            <div key={v} className={className}>
              {handleLabel(v)}
              {item}
            </div>
        );
      }
      return '';
    });
  };
  return <div className="modify-log-change">{handle(data)}</div>;
};
